/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BuilderNavigationService, BuilderUserContext, FormStateBuilder } from '@gh/builder-shared';
import { OfficeType } from '@gh/builder-shared-data';
import { AppRouter, filterableForm, FilterableFormState, getRouteInitData } from '@gh/common-shared';
import { filterTracker, RouteDataService } from '@gh/core-data';
import { cursorTracker, newGridPaginationCursor } from '@gh/core-ui-grid';
import { OfficeUserListBusinessService } from '../../resources/office-user-list-business.service';
import { UserListItem } from '../../resources/office-user-list-item.model';
import { OfficeUserGridDefinition } from './office-user-grid-definition.service';
import { newFormControl, NotificationService } from '@gh/core-ui';

@Component({
  selector: 'gh-office-user-list-tab',
  template: require('./office-user-list-tab.component.html'),
  styles: [require('./office-user-list-tab.component.scss')],
  providers: [OfficeUserGridDefinition],
})
export class OfficeUserListTabComponent implements OnInit {
  userList: UserListItem[] = [];
  cursor = newGridPaginationCursor();
  form: FilterableFormState<any>;
  filter: any;
  showInactive = newFormControl(false);

  constructor(
    private router: AppRouter,
    private route: ActivatedRoute,
    private routeData: RouteDataService,
    private angRouter: Router,
    private notification: NotificationService,
    private formStateBuilder: FormStateBuilder,
    private navigationService: BuilderNavigationService,
    private businessService: OfficeUserListBusinessService,
    public gridDefinition: OfficeUserGridDefinition,
    private userContext: BuilderUserContext,
  ) {
  }

  get isTemplateOffice(): boolean {
    const { office } = this.userContext;
    return office ? office.type === OfficeType.Template : false;
  }

  /**
   * Init component
   */
  ngOnInit(): void {
    const { gridLayout } = getRouteInitData(this.route);
    this.gridDefinition.bind(gridLayout);
    this.form = filterableForm(this.formStateBuilder.buildPlain(
      {
        value:    {},
        children: {
          searchString: void 0,
          showInactive: void 0,
        },
      }));
    const tracker = this.routeData.tracker(filterTracker(this.form)).withEffects(cursorTracker(this.cursor));
    tracker.listen(this.route);
    tracker.filterChanges.subscribe(([filter]) => {
      this.filter = {
        ...filter,
      };
      this.loadData(this.filter);
    });
  }

  onEdit(user: UserListItem): void {
    const url = this.angRouter.serializeUrl(
      this.angRouter.createUrlTree([`office-view/${user.officeId}/setup/users`, user.userId]));
    window.open(url, '_blank');
  }

  goToAel(user: UserListItem): void {
    const url = this.angRouter.serializeUrl(
      this.angRouter.createUrlTree([`office-view/${user.officeId}/ael`]));
    window.open(url + `?entityType=USER&entityId=${user.userId}&label=lbl_users_list`, '_blank');
  }

  onSearch(): void {
    this.form.emitFilter();
  }

  private loadData(filter: any): void {
    this.businessService.getOfficeUserList(filter).subscribe((res) => {
      this.userList = res;
    },                                                       (error) => this.notification.processAll(error));
  }

}
